module.exports = __webpack_public_path__ + "img/snswadai.d0bc6283.png";